import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Input } from "#components/atoms/Input/Input";

type MachineNameCellProps = {
  value: string | null;
  onUpdate: (value: string) => void;
};

export const MachineNameCell = ({ value, onUpdate }: MachineNameCellProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(value ?? "");

  useEffect(() => {
    setInputValue(value ?? "");
  }, [value]);

  return (
    <Input
      value={inputValue}
      onChange={setInputValue}
      onBlur={() => {
        if (inputValue !== (value ?? "")) {
          onUpdate(inputValue);
        }
      }}
      placeholder={t("onboardingV2.processStepConfiguration.columns.machinePlaceholder")}
      aria-label={t("onboardingV2.processStepConfiguration.columns.machine")}
    />
  );
};
